/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-empty-pattern */
/* eslint-disable no-unused-vars */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { PriceSlider } from './PriceSlider';
import { exceptThisSymbols } from '../../../../constants/filterSectionConstant';
// import { TitleCase } from '../../redux/helper/CamelCase';
import CategoryManager from './CategoryManager';
import CustomFilter from './CustomFilters';

function FilterSection(
    {
        // handlePayload,
        payload,
        setpriceRange,
        priceRange,
        Size,
        setSize,
        handleApply,
        Filters,
        Segments,
        setSegments,
        handleIsExist,
        handleSelect,
        handleCheckBox,
        checkBox,
        handleClear,
        uniqCount,
        result,
        sizeList,
        lengthList,
        clearLoader,
        setClearLoader,
    },
) {
    useEffect(() => {
        setClearLoader(false);
    }, [clearLoader]);
    return (
        <div className="xl:block min-w-[20%] max-w-[26%] bg-[#FFFFFF] pl-6 pr-3.5 pt-[26px] pb-[100px] border-r border-[#A5A5A5]  main-screen sticky top-[241px] overflow-auto">
            <div className="flex justify-between">
                <p className="text-lg font-bold text-[#15090E]">Filter by</p>
                <p
                    className="text-sm30 text-[#ED1C24] cursor-pointer"
                    onClick={() => handleClear()}
                >
                    Clear Filter

                </p>
            </div>

            <div className="pt-3.5">
                <div className="pt-1">
                    <p className="text-xs7 font-bold text-[#555259]">Category</p>
                    <div className="h-[140px] dropdown-menu overflow-auto mt-[10px] cursor-pointer">
                        {Object.keys(Filters).length > 0 && (
                            <CategoryManager
                                Filters={Filters}
                                checkBox={checkBox}
                                handleCheckBox={handleCheckBox}
                                Segments={Segments}
                            />
                        )}
                        {!clearLoader && result?.length > 0 && <CustomFilter result={result} Segments={Segments} handleCheckBox={handleCheckBox} />}

                    </div>
                </div>
                <div className="pt-3">
                    <p className="text-xs7 font-bold text-[#555259]">Size(mm)</p>
                    <div className="flex pt-1.5 -mx-2.5">
                        <div className="flex flex-col w-1/2 px-2.5">
                            <label htmlFor="Diameter" className="text-[#555259] font-normal text-xs2 pb-1.5 diameter">Diameter</label>
                            <select
                                onChange={(e) => setSize((state) => ({
                                    ...state,
                                    DIAMETER: e.target.value,
                                }))}
                                type="number"
                                id="Diameter"
                                value={Size.DIAMETER}
                                placeholder="Enter Diameter in mm"
                                className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-[#090406] pl-1 pr-1.5 placeholder:text-[#808285] datepicker-input text-[13px] leading-5"
                            >
                                <option value="">Select Diameter</option>
                                {sizeList && sizeList.map((item, index) => (
                                    <option key={index} value={item.DIAMETER}>{item.DIAMETER}</option>
                                ))}
                            </select>
                        </div>
                        <div className="flex flex-col w-1/2 px-2.5">
                            <label htmlFor="length" className="text-[#555259] font-normal text-xs2 pb-1.5 diameter">Length</label>
                            <select
                                onChange={(e) => {
                                    setSize((state) => ({
                                        ...state,
                                        LENGTH: e.target.value,
                                    }));
                                }}
                                type="number"
                                id="length"
                                className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-[#090406] pl-1 pr-1.5 placeholder:text-[#808285] datepicker-input text-[13px] leading-5"
                                placeholder="Enter Length in mm"
                                value={Size.LENGTH}
                            >
                                <option value="">Select Length</option>
                                {lengthList && lengthList.map((item, index) => (
                                    <option key={index} value={item.LENGTH}>{item.LENGTH}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="pt-18">
                    <p className="text-xs7 font-bold text-[#555259] relative">Price range</p>
                    <div className="relative">
                        <div className="pt-3.5 flex justify-between">
                            <p className="text-xs2 font-semibold text-[#000000]">₹ 0</p>
                            <p className="text-xs2 font-semibold text-[#000000]">₹ 50,000</p>
                        </div>
                        <div className=" mt-2 mb-4">
                            <div className="flex justify-center items-center">
                                <div x-data="range()" x-init="mintrigger(); maxtrigger()" className="relative max-w-xl w-full">
                                    <div>
                                        <PriceSlider setpriceRange={setpriceRange} priceRange={priceRange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pt-3.5">

                    <div className="px-1 flex items-center">
                        <div className="relative w-1/2">
                            <input
                                onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                                type="number"
                                id=""
                                value={priceRange.minValue}
                                onChange={(e) => setpriceRange((state) => ({
                                    ...state,
                                    minValue: e.target.value,
                                }))}
                                className="bg-[#FFFFFF] w-full rounded border border-[#A5A5A5] outline-0 py-1 px-1.5 text-xs6 font-semibold text-[#000000] text-end"
                            />
                            <p className="text-xs6 font-semibold text-[#000000] absolute top-[5px] left-[5px] bg-[#FFFFFF]">₹</p>
                        </div>
                        <span className="text-xs6 font-semibold text-[#000000] px-5">-</span>
                        <div className="relative w-1/2">
                            <input
                                onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                                onChange={(e) => setpriceRange((state) => ({
                                    ...state,
                                    maxValue: e.target.value,
                                }))}
                                type="number"
                                id=""
                                value={priceRange.maxValue}
                                className="bg-[#FFFFFF] w-full rounded border border-[#A5A5A5] outline-0 py-1 px-1.5 text-xs6 font-semibold text-[#000000] text-end"
                            />
                            <p className="text-xs6 font-semibold text-[#000000] absolute top-[5px] left-[5px] bg-[#FFFFFF]">₹</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-3">
                <button onClick={() => handleApply()} type="button" className="w-full h-10 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold text-[#FFFFFF]">
                    Apply Filter
                </button>
            </div>
        </div>
    );
}

export default FilterSection;
